import { CheckBox } from 'devextreme-react/check-box';
import { SelectBox } from 'devextreme-react/select-box';
import { formatDate, formatNumber } from 'devextreme/localization';
import { useContext, } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useGetCompanyUsers } from '../../../../api/users';
import { useAuth } from '../../../../contexts/auth';
import { Field, Panel } from '../../../../layouts';
import { OrderStatus, ROType } from '../../../../types/enums';
import { formatShortDateShortTime } from '../../../../utils/date-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderInformationPanel(props: { showProjectManager: boolean }) {

	const { order, modifyOrder } = useContext(RetailOrderContext);

	const { user } = useAuth();
	const companyUsers = useGetCompanyUsers(user?.companyId!);

	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	return (
		<>
			<Panel
				header={'Retail Order Information'}
			>
				<Field label={'Retail Order #'} showCopyToClipboard={true} >{order.details.roNumber}</Field>
				<Field label={'Order Type'} >{order.details.roType}</Field>
				<Field label={'Order Total'} >{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}</Field>
				<Field label={'Order Status'} >{order.details.orderStatus}</Field>
				<Field label={'Hold Reason'} visible={order.details.orderStatusID === OrderStatus.Hold}>{order.details.holdReason}</Field>
				<Field label={'IME Status'} visible={order.details.IME}>{order.details.imeStatus}</Field>
				<Field label={'Order Date'} >{formatDate(new Date(order.details.roDate), 'shortDate')}</Field>
				<Field label={'Order Creation Date'} >{formatShortDateShortTime(new Date(order.details.createdOn))}</Field>
				{order.details.quoteNumber && <Field label={'Estimate #'} showCopyToClipboard={true}>{order.details.quoteNumber}</Field>}
				<Field label={'Project #'} showCopyToClipboard={true} >{order.details.projectNumber}</Field>
				{
					props.showProjectManager && order.details.roTypeID !== ROType.Plumbing &&
					<Field label={'Project Manager'}>
						<SelectBox elementAttr={{ 'data-testid': 'dd-project-manager' }}
							dataSource={companyUsers?.data.filter(x => x.groups?.includes('Project Manager') && (!x.inactive || x.userName === order.details.projectManager))}
							valueExpr={'userName'}
							displayExpr={'fullName'}
							showClearButton={true}
							value={order.details.projectManager}
							onValueChanged={(e) => modifyOrder({ ...order.details, projectManager: e.value })}
						>
						</SelectBox>
					</Field>
				}
				<Field label={'SF&I Lead Date'} visible={order.details.IME && order.details.roTypeID !== ROType.Plumbing}>
					{order.details.leadCreatedOn ? formatDate(new Date(order.details.leadCreatedOn), 'shortDate') : ''}
				</Field>
				<Field label={'Parent Retail Order #'} visible={!!order.details.linkedROID}>
					<Link to={'/cfi/retail-order/' + order.details.linkedROID + (!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
						{order.details.linkedRONumber}
					</Link>
				</Field>
				{
					order.details?.addons && order.details?.addons.length > 0 &&
					<Field label={'Related Retail Orders'}>
						<table className='addons'>
							<tbody>
								{
									order.details?.addons.map((addon) => {
										return (
											<tr key={addon.retailOrderID}>
												<td>
													<Link to={'/cfi/retail-order/' + addon.retailOrderID + (!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
														{addon.roNumber}
													</Link>
												</td>
												<td>
													{formatNumber(addon.amount, { type: 'currency', precision: 2 })}
												</td>
											</tr>
										)
									})
								}
								<tr>
									<td></td>
									<td className='addon-total'>
										{formatNumber(order.details?.addons.reduce((a, b) => a + b.amount, 0), { type: 'currency', precision: 2 })}
									</td>
								</tr>
							</tbody>
						</table>
					</Field>
				}
				<Field label={'Cancellation Requested'}>
					<CheckBox readOnly={true} value={!!order.details.cancellationReason}></CheckBox>
				</Field>
			</Panel>
		</>
	);
}
